module.exports = __webpack_public_path__ + "static/media/share-all.e1f3a7b1.svg";